import { render, staticRenderFns } from "./FacilityInfo.vue?vue&type=template&id=005d663c&scoped=true"
import script from "./FacilityInfo.vue?vue&type=script&lang=js"
export * from "./FacilityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d663c",
  null
  
)

export default component.exports